import { Channels } from "../channel/types";
import { getNow } from "../server-now";

const isInYaldPeriod = (): boolean => {
  const now = new Date(getNow());

  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  return year === 2025 && month === 11 && day >= 16 && day <= 23;
};

export const getYaldaLogo = (channel: Channels) => {
  const isYaldaPeriod = isInYaldPeriod();
  const isAllowedChannel = ["jek", "website"].includes(channel);
  if (isYaldaPeriod && isAllowedChannel) {
    return {
      label: "snapptrip",
      image: {
        src: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/yalda/yalda-logo.webp`
      },
      width: 44,
      height: 44,
      title: "اسنپ تریپ"
    };
  }
  return null;
};
